<section class="p-6">

  <!-- Account Tabs -->
  <app-account-tabs></app-account-tabs>

  <div class="px-4 sm:px-0">

    <div class="flex justify-between items-center">

      <div class="w-full md:h-[36rem] md:min-h-[36rem]">

        <div *ngIf="invoices.length === 0" class="flex justify-center items-center h-full">
          <div class="text-center">
            <h3 class="mt-2 font-semibold text-secondary">Invoices</h3>
            <p class="mt-1 text-sm font-medium text-secondary/75">There is no invoice available.</p>

          </div>

        </div>

        <div *ngIf="invoices.length > 0" class="overflow-hidden">
          <div class="mx-auto max-w-7xl">
            <div class="mx-auto max-w-2xl lg:mx-0 lg:max-w-none">
              <table class="w-full text-left">
                <thead class="sr-only">
                <tr>
                  <th>Amount</th>
                  <th class="hidden sm:table-cell">Client</th>
                  <th>More details</th>
                </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let invoice of invoices; let i = index">
                    <td class="relative py-5 pr-6">
                      <div class="flex gap-x-6">
                        <div class="flex-auto">
                          <div class="flex items-start gap-x-3">
                            <div class="text-sm font-medium leading-6 text-gray-700">{{ invoice.price }} {{ invoice.currency }}</div>
                            <div class="rounded-md py-1 px-2 text-xs font-medium ring-1 ring-inset text-green-700 bg-green-50 ring-green-600/20">Paid</div>
                          </div>
                          <!--
                          <div class="mt-1 text-xs leading-5 text-gray-500">Description</div>
                          -->
                        </div>
                      </div>
                      <div class="absolute bottom-0 right-full h-px w-screen bg-gray-100"></div>
                      <div class="absolute bottom-0 left-0 h-px w-screen bg-gray-100"></div>
                    </td>
                    <td class="hidden py-5 pr-6 sm:table-cell">
                      <div class="text-sm leading-6 text-gray-700">{{ invoice.product_name }}</div>
                      <!--
                      <div class="mt-1 text-xs leading-5 text-gray-500">Description</div>
                      -->
                    </td>
                    <td class="py-5 text-right">
                      <div class="flex justify-end">
                        <button type="button" (click)="viewInvoice(invoice.id)" class="text-sm font-medium leading-6 text-indigo-600 hover:text-indigo-500">View invoice<span class="sr-only">, invoice #00012, Reform</span></button>
                      </div>
                      <div class="mt-1 text-xs leading-5 text-gray-500">Invoice {{ invoice.series }} {{ invoice.number }}</div>
                    </td>
                  </tr>


                </tbody>
              </table>

              <!-- Pagination -->
              <div class="flex items-center justify-between bg-white dark:bg-indigo-custom rounded-b-lg py-3 pb-0">
                <app-pagination (pageChanged)="onPageChanged($event)" [pagination]="pagination" class="w-full"></app-pagination>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

</section>
